var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.871 0.0601807H17.1277C6.81435 0.0601807 0.666016 6.20851 0.666016 16.5218V40.2368C0.666016 50.5785 6.81435 56.7268 17.1277 56.7268H40.8427C51.156 56.7268 57.3043 50.5785 57.3043 40.2652V16.5218C57.3327 6.20851 51.1843 0.0601807 40.871 0.0601807ZM40.5027 34.0602C40.0777 34.4852 39.5393 34.6835 39.001 34.6835C38.4627 34.6835 37.9243 34.4568 37.4993 34.0602L28.9993 25.5602L20.4993 34.0602C19.6777 34.8818 18.3177 34.8818 17.496 34.0602C16.6743 33.2385 16.6743 31.8785 17.496 31.0568L27.4977 21.0552C28.3193 20.2335 29.6793 20.2335 30.501 21.0552L40.5027 31.0568C41.3243 31.8785 41.3243 33.2102 40.5027 34.0602Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.72e532068caa740d5aeb3015820c4a39.svg";
export { ForwardRef as ReactComponent };